import React, { useEffect, useState } from 'react'
import Loader from '../../components/Loader'
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import HeaderCustomerPreview from '../../layout/header/HeaderCustomerPreview';
import { Box, Button } from '@mui/material';
import SnackbarAlert from '../../shared-components/snackbar-alert/SnackbarAlert';
import { eoiExportAsPDF, getMasterDataList, getVoucherById } from '../voucher-form/voucher-form.slice';
import ApplicantDetails from './components/voucher-components/ApplicantDetails';
import PaymentDetails from './components/PaymentDetails';
import KYCDocuments from './components/KYCDocuments';
import OtherApplicantDetails from './components/voucher-components/OtherApplicantDetails';
import { PreviewThankYou } from './components/voucher-components/PreviewThankYou';
import { TermsAndConditions } from './components/voucher-components/TermsAndConditions';
import { ReferrerDetails } from './components/voucher-components/ReferrerDetails';
import { PRIMARY_SOURCE } from '../../config/constant';
import exportIcon from '../../assets/icons/export-icon.svg'
import RefundDetails from './components/voucher-components/RefundDetails';

const VoucherPreview = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { applicantData, isLoading, masterData, eoiCampaignDetails, } = useSelector((state) => state?.voucherForm);
  const { voucherId } = useParams();
  const termsAndConditionsdData = eoiCampaignDetails?.eoiTermsAndCondition || eoiCampaignDetails?.voucherTermsAndCondition;
  const [snackbarConfig, setSnackBarconfig] = useState({
    open: false,
    message: "",
    severity: "",
  });

  useEffect(() => {
    if (voucherId) {
      dispatch(getVoucherById(`/${voucherId}`));
      dispatch(getMasterDataList());
      window.scrollTo(0, 0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [voucherId]);

  const handleSnackbarClose = () => {
    setSnackBarconfig({
      open: false,
      message: "",
      severity: "",
    });
  };

  const handleExportPDF = () => {
    dispatch(eoiExportAsPDF(voucherId))
      .unwrap()
      .catch((error) => {
        setSnackBarconfig({
          open: true,
          message: error?.errors?.message || "Failed to export PDF",
          severity: "error",
        });
      });
  };

  return (
    <>
      {isLoading && <Loader isLoading={isLoading} />}
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <HeaderCustomerPreview />

      {/* <Header /> */}
      {applicantData !== null ? (
        <div className="CustomerPreviewWrapper">
          <Box
            sx={{
              fontSize: "22px",
              fontWeight: "500",
              textAlign: 'center',
              color: '#1A407D',
              marginBottom: {
                xs: '20px',
                sm: '0px',
              },
              display: {
                xs: 'block',
                sm: 'none',
              },
            }}
          >
            {t("voucherPreview.title")}
          </Box>
          {/* <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mb: 2,
            }}
          >
            <Button
              size="large"
              variant="contained"
              sx={{
                backgroundColor: "#1A407D",
                textTransform: "none",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                "&:hover": {
                  backgroundColor: "#1A407D",
                },
              }}
              onClick={handleExportPDF}
            >
              <img src={exportIcon} alt="" width={20} height={20} />
              Export as PDF
            </Button>

          </Box> */}

          <PreviewThankYou applicantData={applicantData} />
          <PaymentDetails applicantData={applicantData} />
          <ApplicantDetails applicantData={applicantData} masterData={masterData} />
          <OtherApplicantDetails applicantData={applicantData} />
          <KYCDocuments applicantData={applicantData} formType="voucher" />
          {[
            PRIMARY_SOURCE.ProvidentPremiere,
            PRIMARY_SOURCE.PurvaPrivilege,
            PRIMARY_SOURCE.PurvaChampion
          ].includes(applicantData?.primarySource) && (
              <ReferrerDetails applicantData={applicantData} />
            )}
          <RefundDetails applicantData={applicantData} />
          <TermsAndConditions termsAndConditionsData={termsAndConditionsdData} />

          <SnackbarAlert
            open={snackbarConfig.open}
            message={snackbarConfig.message}
            severity={snackbarConfig.severity}
            onClose={handleSnackbarClose}
          />
        </div>
      ) : null}
    </>
  )
}

export default VoucherPreview